import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { HelpArticleForm } from '@/admin/sitecontent/HelpArticleForm';
import { parsePositiveInt } from '@/admin/sitecontent/listSearch';
import { DetailPage } from '@/admin/ui/Editor';
import { BackLink } from '@/admin/ui/NavLinks';
import { PageTitle } from '@/admin/ui/Page';

export const Route = createFileRoute('/admin/help/new')({
  staticData: { minTier: 'ADMIN' },
  validateSearch: (s: Record<string, unknown>): { section?: number } => ({
    section: parsePositiveInt(s.section),
  }),
  component: NewHelpArticle,
});

function NewHelpArticle() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { section } = Route.useSearch();
  return (
    <DetailPage>
      <BackLink>
        <Link to="/admin/help/">{t('admin.help.backToArticles')}</Link>
      </BackLink>
      <PageTitle>{t('admin.help.newArticle')}</PageTitle>
      <HelpArticleForm
        initialSectionId={section}
        onSaved={(id) =>
          navigate({
            to: '/admin/help/$articleId/',
            params: { articleId: String(id) },
          })
        }
        onCancel={() => navigate({ to: '/admin/help/' })}
      />
    </DetailPage>
  );
}
